export default __webpack_public_path__ + "static/footer-students-8761e2466036ede70e1de828b9013131.svg";